module.exports = __webpack_public_path__ + "img/img0.e66b1f01.jpg";